(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poppimo-header"]) return;
  try {
    
document.addEventListener('keydown',function(event){if(event.key!=='Escape')return;document.querySelectorAll('.p-header details[open]').forEach(function(menu){menu.open=false;menu.querySelector('summary').focus();});});
document.addEventListener('click',function(event){document.querySelectorAll('.p-header details[open]').forEach(function(menu){if(!menu.contains(event.target))menu.open=false;});});
document.addEventListener('DOMContentLoaded',function(){const current=new URL(window.location.href);document.querySelectorAll('.p-inline-links a,.p-desktop-nav a,.p-mobile-nav-panel a').forEach(function(link){const target=new URL(link.href);if(target.pathname===current.pathname&&target.searchParams.get('view')===current.searchParams.get('view'))link.setAttribute('aria-current','page');});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poppimo-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change',function(event){const select=event.target.closest('[data-p-variant]');if(!select)return;const info=select.closest('.p-product-info');const option=select.selectedOptions[0];const price=info.querySelector('[data-p-price]');if(price)price.textContent=option.dataset.price;const button=info.querySelector('[data-p-add]');if(button&&!document.querySelector('.p-draft')){button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?button.dataset.unavailableLabel:button.dataset.addLabel;}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poppimo-recommendations"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('poppimo-recommendations')) {
  customElements.define('poppimo-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded) return;
      this.dataset.loaded = 'true';
      fetch(this.dataset.url).then(response => {
        if (!response.ok) throw new Error('Recommendations unavailable');
        return response.text();
      }).then(html => {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const content = parsed.querySelector('poppimo-recommendations');
        if (content && content.innerHTML.trim()) this.innerHTML = content.innerHTML;
      }).catch(() => { this.hidden = true; });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poppimo-spooky-drops"] && !Shopify.designMode) return;
  try {
    
(() => {const setup = root => {
 root.querySelectorAll('.psd__video-wrap video').forEach(video => {
 if(video.dataset.ready)return;video.dataset.ready='true';video.muted=true;video.defaultMuted=true;
 const start=()=>{const source=video.querySelector('source[data-src]');if(source){source.src=source.dataset.src;source.removeAttribute('data-src');video.load()}if(!matchMedia('(prefers-reduced-motion: reduce)').matches)video.play().catch(()=>{})};
 if('IntersectionObserver' in window){new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting)start();else video.pause()}),{rootMargin:'180px'}).observe(video)}else start();
 });root.querySelectorAll('.psd__mobile-nav a').forEach(a=>a.addEventListener('click',()=>a.closest('details').removeAttribute('open')));
};setup(document);document.addEventListener('shopify:section:load',e=>setup(e.target));})();

  } catch(e) { console.error(e); }
})();
})();
